module.exports = __webpack_public_path__ + "static/media/process-warehouse.1ec390b3.svg";